import React, { FC } from 'react';
import { Container } from './styles';
import { Props } from './types';

const SectionMenu: FC<Props> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
);

export default SectionMenu;
